import useVideoPlayer from 'components/hook/useVideoPlayer'
import { PERCENT_MAP, registerTrackingEvents, sendTracking } from 'helpers'
import React, { useEffect, useMemo, useState } from 'react'

const MoAdPlayer = ({ handleMoAdClose, videoUrl, src, isOpenedMoPlayer, adUrl, trackingEvents, clickLogUrl }) => {
    const onVideoEnd = () => {
        handleMoAdClose()
    }

    const {
        videoRef,
        isMuted,
        progress,
        updateProgress,
        toggleMute,
        setOnConditionReached,
        canPlay
    } = useVideoPlayer(videoUrl, isOpenedMoPlayer, onVideoEnd)

    // 광고 시작 이벤트 URL 추출
    const startEventUrl = useMemo(
        () => trackingEvents.find((event) => event.attributes.event === 'start')?.value || '',
        [trackingEvents]
    );
    
    // 트래킹 이벤트 등록
    useEffect(() => {
        const percentEvents = trackingEvents.filter((event) => PERCENT_MAP[event.attributes.event]);
        const progressEvents = trackingEvents.filter((event) => event.attributes.event === 'progress');

        const removePercentListeners = registerTrackingEvents(
            percentEvents,
            setOnConditionReached,
            (event) => sendTracking(event.value)
        );

        const removeProgressListeners = registerTrackingEvents(
            progressEvents,
            setOnConditionReached,
            (event) => sendTracking(event.value)
        );

        const removeStartListener = setOnConditionReached(0, () => sendTracking(startEventUrl));

        return () => {
            removePercentListeners();
            removeProgressListeners();
            removeStartListener();
        };
    }, [setOnConditionReached, trackingEvents, startEventUrl]);

    const handleAdClick = () => {
        sendTracking(clickLogUrl)
    }

    const [isShow, setIsShow] = useState(false);

    useEffect(() => {
        if (canPlay && isOpenedMoPlayer) {
            const timer = setTimeout(() => {
                setIsShow(true);
            }, 200);
            
            return () => clearTimeout(timer);
        } else {
            setIsShow(false);
            
        }

        if (!isOpenedMoPlayer) {
            videoRef.current?.pause()
        }
    }, [canPlay, isOpenedMoPlayer]);

    return (
        <>
            <div id="player" style={{ pointerEvents: isOpenedMoPlayer ? 'auto' : 'none' }}>
                <div className="player_box">
                    <a href={adUrl} target="_blank" onClick={handleAdClick}>
                        <video
                            ref={videoRef}
                            autoPlay
                            muted={isMuted}
                            onTimeUpdate={updateProgress}
                            controls={false}
                            playsInline
                            poster={isShow ? null : src}
                        />
                    </a>
                </div>
            </div>
            <div className="player_blur" style={{ backgroundImage: `url('${src}')`, pointerEvents: 'none' }}></div>
            <div className="ctrlBox">
                <button
                    type="button"
                    className={`sound ${isMuted ? 'mute' : ''}`}
                    onClick={toggleMute}
                >
                    {isMuted ? '음소거' : '소리 켜기'}
                </button>
                <button type="button" className="close" onClick={handleMoAdClose}>
                    닫기
                </button>
            </div>
            <div className="progress_track">
                <div className="watched" style={{ width: `${progress}%` }}></div>
            </div>
        </>
    )
}

export default MoAdPlayer